import React from "react";
import { connect } from "react-redux";
import { useDrop } from "react-dnd";
import { setDropped } from "../../redux/actions/formActions";
const Droppable = ({ children, setDropped, dropped }) => {
	const [collectedProps, drop] = useDrop(() => ({
		accept: "htxt",
		drop: (monitor, props) => {
			setDropped(monitor);
		},
	}));

	return <div ref={drop}>{children}</div>;
};

const mapStateToProps = (state) => {
	return {
		dropped: state.form.dropped,
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		setDropped: (droppedItems) => dispatch(setDropped(droppedItems)),
	};
};
export default connect(mapStateToProps, mapDispatchToProps)(Droppable);
